import { Button, Card, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { AppHelper } from 'utils/app.helpers';
import ModalViewFilesDetails from 'components/ViewFiles';

const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;

const CardWrapper = styled.div`
  margin-bottom: 15px;
`;

interface IModalViewFile {
  isOpen: boolean;
  handleCancel: () => void;
  detail: any;
}
const { Option } = Select;
function ModalViewFileSchool({ isOpen, handleCancel, detail }: IModalViewFile) {
  const [filePath, setFilePaths] = useState<any[]>([]);
  const [filePathScore, setFilePathScore] = useState<any[]>([]);

  //pop up view file
  const [isOpenModalViewFileDetails, setIsOpenModalViewFileDetails] = useState<boolean>(false);
  const [detailFile, setDetailFile] = useState<any>();

  useEffect(() => {
    if (!_.isEmpty(detail.certificates) && !_.isEmpty(detail.certificates_description)) {
      setFilePaths(_.values(detail.certificates));
      setFilePathScore(_.values(detail.certificates_description));
    }
  }, []);

  const handleDownLoad = (filePath: string) => {
    AppHelper.createDownloadFile(filePath);
  };

  const openFile = (item) => {
    setIsOpenModalViewFileDetails(true);
    setDetailFile(item);
  };

  return (
    <Modal
      title={'PHIẾU CHẤM CỦA TRƯỜNG'}
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>
      ]}>
      <Container>
        <CardWrapper>
          <Card>
            <div style={{ fontWeight: 'bold' }}>Giám khảo 1</div>
            <div>Không có file đính kèm</div>
          </Card>
        </CardWrapper>
        <CardWrapper>
          <Card>
            <div style={{ fontWeight: 'bold' }}>Giám khảo 2</div>
            <div>Không có file đính kèm</div>
          </Card>
        </CardWrapper>
      </Container>
      {isOpenModalViewFileDetails && (
        <ModalViewFilesDetails
          isOpen={isOpenModalViewFileDetails}
          detail={detailFile}
          handleCancel={() => setIsOpenModalViewFileDetails(false)}
        />
      )}
    </Modal>
  );
}
export default ModalViewFileSchool;
